import { PatientDocumentControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useAssignToPatient = () =>
  useMutationWithLoading(
    async (param: { patientDocumentId: string; xTENANTID?: string }) =>
      new PatientDocumentControllerApi(
        getConfigObject()
      ).assignDocumentToPatient(
        param.patientDocumentId,
        param.xTENANTID //xTENANTID
      )
  );
